module.exports = __webpack_public_path__ + "img/2ne.72108495.svg";